// removed by extract-text-webpack-plugin
module.exports = {"container":"checkbox-input__container__2UCZt","label":"checkbox-input__label__2znql","checkmark":"checkbox-input__checkmark__3RiAx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/checkbox-input.scss
// module id = 1381
// module chunks = 1